let log = {
    name: "Admin Name",
    time: "Time",
    time_range: "Time Range",
    action: "Action",
    action_object: "Action Object",
    action_result: "Action Result",
    result_success: "Success",
    result_failed: "Failed",
    result_exception: "Exception",
    push_time: "Push Time",
    push_time_range: "Push Time Range",
    action_detail: "Log detail",
    action_descp: "Log detail"
}

export default log